import * as Enum from '@owl-nest/legacy-enum'

export const BRAND_ACTION = Enum.create({
  IMPRESSION: 'Brand Impression',
  IMPRESSION_CLICKABLE: 'Brand Impression Clickable',
  CLICK: 'Brand click',
  ON_PAGE: 'Brands on page',
})
export type BRAND_ACTION = Enum.ValueOf<typeof BRAND_ACTION>

export const ACTION = Enum.create({
  FOLLOW_PROJECT: 'follow_project',
})
export type ACTION = Enum.ValueOf<typeof ACTION>

export const CATEGORY = Enum.create({
  BOUTIQUE: 'Boutique',
  CHECKOUT: 'Checkout',
  DISCOVER_ULULE: 'Discover Ulule',
  HOMEPAGE: 'Homepage',
  // NOTE: If you come across this entry and the Boutique End of Life page (ulule.com/boutique) no longer exists, please remove this.
  BOUTIQUE_END_OF_LIFE_PAGE: 'Homepage boutique',
  MEMBERSHIP_NEWS: 'Membership post',
  MEMBERSHIP_PAGE: 'Membership page',
  PARTNERS_OPERATIONS: 'Partners operations',
  PROJECT_FORM: 'project_form',
  PROJECT_PAGE: 'project_page',
  PROJECT_PROPOSAL_TRACKING: 'Project proposal',
  REGISTRATION: 'User registration',
  SOCIAL: 'social on Ulule',
  ULULE: 'Ulule',
  WIDGET: 'External widget',
})
export type CATEGORY = Enum.ValueOf<typeof CATEGORY>

export const EVENT_TYPE = Enum.create({
  BRAND: 'BRANDevent',
  GENERIC: 'GAevent',
  GENERATE_LEAD: 'generate_lead',
  PROJECT_FORM_ERROR: 'projectFormError',
  SOCIAL: 'socialInt',
  TRANSACTION: 'transaction',
})
export type EVENT_TYPE = Enum.ValueOf<typeof EVENT_TYPE>

export const SITE = Enum.create({
  CHECKOUT: 'Checkout',
  ULULE: 'Ulule',
  WIDGET: 'External widget',
  CONNECT: 'Connect',
})
export type SITE = Enum.ValueOf<typeof SITE>

export const SOCIAL_NETWORK = Enum.create({
  FACEBOOK: 'Facebook',
  HYPERLINK: 'Hyperlink',
  LINKEDIN: 'Linkedin',
  MESSENGER: 'Messenger',
  NATIVE: 'Native',
  TWITTER: 'Twitter',
  ULULE: 'Ulule',
  WHATSAPP: 'WhatsApp',
  WIDGET: 'Widget',
})
export type SOCIAL_NETWORK = Enum.ValueOf<typeof SOCIAL_NETWORK>

export const apiTagTypeToGTM = {
  facebook: 'poFBpixelID',
  google: 'poGApropertyID',
  tiktok: 'poTTpixelID',
  twitter: 'poTWpixelID',
} as const

type AnalyticsTagType = (typeof apiTagTypeToGTM)[keyof typeof apiTagTypeToGTM]

export type AnalyticsTags = {
  [key in AnalyticsTagType]?: string
}

export type BaseTracking<EVENT extends Partial<TrackingEvent> = Partial<TrackingEvent>> = {
  track: (event: EVENT) => void
}

export type BrandEvent = {
  event: typeof EVENT_TYPE.BRAND
  eventAction: BRAND_ACTION
  eventCategory: 'Brand visibility'
  eventLabel: string
  eventValue?: string
  logoId?: string
  nonInteractionEvent?: boolean
  linkUrl?: string
  eventTimeout?: number
  eventCallback?: () => void
}

export type GenericEvent = {
  event: typeof EVENT_TYPE.GENERIC
  eventCategory: CATEGORY
  pageCategory: string
  siteCategory: SITE
  eventAction: string
  eventValue?: string
  eventLabel?: string
  eventTimeout?: number
  eventCallback?: () => void
}

export type LeadEvent = {
  event: typeof EVENT_TYPE.GENERATE_LEAD
  eventCallback?: () => void
  eventTimeout?: number
  leadSource?: string
}

export type SocialEvent = {
  event: typeof EVENT_TYPE.SOCIAL
  eventCallback?: () => void
  eventCategory?: CATEGORY
  eventTimeout?: number
  socialAction: string
  socialNetwork: SOCIAL_NETWORK
  socialTarget: string
  ululeProjectId?: number
  eventAction?: string
  eventLabel?: string
  eventValue?: string
}

export type TransactionEvent = {
  event: typeof EVENT_TYPE.TRANSACTION
  eventCallback?: () => void
  transactionId: number
  transactionAffiliation: 'Ulule'
  transactionTotal: number
  transactionCurrencyCode: string
  transactionProducts?: TransactionProductEvent[]
  ululeProjectId: number
}

export type TransactionProductEvent = {
  sku: number
  price: number
  quantity: number
}

export type RecommandedEvent = {
  0: 'event'
  1: string
  2: unknown
  eventCallback?: () => void
}

export type EcommerceEvent = {
  event: string
  ecommerce: any
  eventCallback?: () => void
}

export type TrackingEvent =
  | GenericEvent
  | LeadEvent
  | SocialEvent
  | TransactionEvent
  | BrandEvent
  | RecommandedEvent
  | EcommerceEvent
